<template>
  <th :class="{ reduced: isHidden }">

    <span class="eye" @click="toggleHide" v-if="!isHidden">
      <span class="fas fa-eye"/>
    </span>

    <span class="eye-slash" v-else @click="toggleHide">
      <span class="fas fa-eye-slash"/>
    </span>

    <span class="header-content" @click="onSort">
      <span class="header-title">
        <slot v-if="!isHidden"></slot>
      </span>

      <span v-if="!isHidden && orderSymbole" class="order" :class="{active: CustomTableService.data.get(this.tableId).fields.sortedField === this.field}">
        {{ orderSymbole }}
      </span>
    </span>
  </th>
</template>

<script>
import { CustomTableService } from "@/services/CustomTableService";
import { SORT_OPERATOR_ENUM } from "@/models/sortOperatorEnum";

export default {
  props: {
    field: {type: String},
    // false pour une colonne calculée (non triable côté base)
    sortable: {type: Boolean, default: true},
  },
  inject: ["tableId"],

  computed: {
    CustomTableService() {
      return CustomTableService;
    },

    isHidden() {
      return CustomTableService.data
          .get(this.tableId)
          .fields.hiddenField?.[this.field];
    },

    orderSymbole() {
      const table = CustomTableService.data.get(this.tableId);

      if (!this.sortable) return '';

      if (
          table.fields.sortedField === this.field &&
          table.fields.sortOrder !== 0
      ) {
        return table.fields.sortOrder === 1 ? '▲' : '▼';
      }

      if (
          table.fields.sortedField !== this.field &&
          !this.isHidden
      ) {
        return '▲';
      }

      return '';
    },

    table() {
      return CustomTableService.data.get(this.tableId);
    }
  },

  watch: {
    table: {
      handler(newTable) {
        if (!newTable) return;

        if (newTable.currentSort.length === 0) {
          newTable.fields.sortedField = null;
          newTable.fields.sortOrder = 0;
          return;
        }

        const sort = newTable.currentSort[0];

        newTable.fields.sortedField = sort.field;
        newTable.fields.sortOrder =
            sort.order === SORT_OPERATOR_ENUM.ASCENDING.value ? 1 : 2;
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    toggleHide() {
      const table = CustomTableService.data.get(this.tableId);

      table.fields.hiddenField ||= {};

      table.fields.hiddenField[this.field] =
          !table.fields.hiddenField[this.field];
    },

    onSort() {
      if (!this.sortable) return;

      const table = CustomTableService.data.get(this.tableId);

      let order = 0;

      if (table.fields.sortedField !== this.field) {
        order = 1;
      } else {
        order = (table.fields.sortOrder + 1) % 3;
      }

      this.handleSortChange({
        field: this.field,
        order
      });
    },

    handleSortChange({ field, order }) {
      const table = CustomTableService.data.get(this.tableId);

      table.currentSort =
          order === 0
              ? []
              : [{
                field,
                order: order === 1
                    ? SORT_OPERATOR_ENUM.ASCENDING.value
                    : SORT_OPERATOR_ENUM.DESCENDING.value
              }];

      table.loadData();
    }
  }
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl'

th
  cursor pointer
  min-width 0
  max-width 100%
  overflow hidden
  white-space nowrap

  .eye
    color #8f9ab8
    margin-right 10px
    cursor pointer

  .eye-slash
    color #8f9ab8
    cursor pointer

  .header-content
    display inline-block
    max-width 100%
    min-width 0
    vertical-align middle

  .header-title
    display inline-block
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
    vertical-align middle

  .order
    display inline-block
    width 14px
    margin-left 10px
    opacity 0
    vertical-align middle

  .order.active
    opacity 1

  &:hover .order
    opacity 0.3

  &.reduced
    width 20px
    min-width 20px
    max-width 20px
    text-align center
</style>